import React from 'react';
import UnifiedRegistrationForm from '../components/forms/UnifiedRegistrationForm';
import './Registration.css';

import { 
  FaClipboardList, 
  FaFire, 
  FaUtensils,
  FaBaby,
  FaArrowDown
} from 'react-icons/fa';

import { GiBarbecue } from 'react-icons/gi';

const Registration = () => {
  return (
    <div className="registration-container">
      <div className="hero-section">
        <div className="hero-background-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="hero-content">
          <h1><FaClipboardList className="hero-icon" />Register for the Cookoff</h1>
          <p className="hero-subtitle">
            Select what you'd like to register for and complete checkout!
          </p>
          <div className="registration-types">
            <div className="reg-type">
              <GiBarbecue className="reg-icon" />
              <span>BBQ Teams ($200)</span>
            </div>
            <div className="reg-divider"></div>
            <div className="reg-type">
              <FaUtensils className="reg-icon" />
              <span>Jackpot Categories ($25 each)</span>
            </div>
            <div className="reg-divider"></div>
            <div className="reg-type">
              <FaBaby className="reg-icon" />
              <span>Kids Cookoff ($25 each)</span>
            </div>
          </div>
          <div className="scroll-indicator">
            <FaArrowDown className="scroll-arrow" />
            <span>Complete registration below</span>
          </div>
        </div>
      </div>
      
      <UnifiedRegistrationForm />
    </div>
  );
};

export default Registration; 